import { useGridPreferencesPanel } from '@material-ui/data-grid';
import { useEffect, useState } from 'react';

function useGroupedCheckbox({ dataArray, setDataArray, childAttribute = 'permissions', callback = undefined }) {
  const [grandChecked, setGrandChecked] = useState({
    checked: false,
    indeterminate: false,
  });

  /**
   * ? [childAttribute] es una propiedad del objeto xd
   */
  function toggleChildCheckbox(parentIndex, childIndex) {
    let checked = !dataArray[parentIndex][childAttribute][childIndex].checked;
    dataArray[parentIndex][childAttribute][childIndex].checked = checked;

    let childChecked = dataArray[parentIndex][childAttribute].reduce(
      (count, p) => count + (!!p.checked ? 1 : 0),
      0
    );

    if (childChecked == 0) {
      dataArray[parentIndex].checked = false;
      dataArray[parentIndex].indeterminate = false;
    } else if (dataArray[parentIndex][childAttribute].length == childChecked) {
      dataArray[parentIndex].checked = true;
      dataArray[parentIndex].indeterminate = false;
    } else {
      dataArray[parentIndex].checked = false;
      dataArray[parentIndex].indeterminate = true;
    }
    let newData = [...dataArray];
    setDataArray(newData);
  }

  function toggleParentCheckbox(parentIndex) {
    let checked = !dataArray[parentIndex].checked;
    dataArray[parentIndex][childAttribute].map((p) => (p.checked = checked));
    dataArray[parentIndex].checked = checked;
    dataArray[parentIndex].indeterminate = false;
    let newData = [...dataArray];
    setDataArray(newData);
  }

  function toggleGrandParentCheckbox() {
    let checked = !grandChecked.checked;
    grandChecked.indeterminate = false;
    dataArray.map((parent) => {
      parent.checked = checked;
      parent.indeterminate = false;

      parent[childAttribute].map((p) => {
        p.checked = checked;
        p.indeterminate = false;
      });
    });

    setGrandChecked({ ...grandChecked, checked });
    setDataArray([...dataArray]);
  }

  function verifyGrandCheck() {
    let parentChecked = dataArray.reduce((count, p) => {
      if (!!p.checked) {
        return count + 1;
      }
      if (!!p.indeterminate) {
        return count + 0.5;
      }
      return count;
    }, 0);

    if (parentChecked == 0) {
      grandChecked.checked = false;
      grandChecked.indeterminate = false;
    } else if (parentChecked == dataArray.length) {
      grandChecked.checked = true;
      grandChecked.indeterminate = false;
    } else {
      grandChecked.checked = false;
      grandChecked.indeterminate = true;
    }
    setGrandChecked({ ...grandChecked });
    if (!!callback) {
      callback(getCheckeds());
    }
  }

  function getCheckeds(idAttribute = 'id') {
    let ids = [];

    dataArray.forEach((item) => {
      if (!!item.checked) {
        ids.push(item[idAttribute]);
      }
      item[childAttribute].forEach((child) => {
        if (!!child.checked) {
          ids.push(child[idAttribute]);
        }
      });
    });
    return ids;
  }

  useEffect(() => {
    verifyGrandCheck();
  }, [dataArray]);

  return {
    grandChecked,
    toggleChildCheckbox,
    toggleParentCheckbox,
    toggleGrandParentCheckbox,
    getCheckeds
  };
}

export { useGroupedCheckbox };
